// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__e2Ule","textContainer":"styles_textContainer__oOu5Q","title":"styles_title__0ZZBX","gradient":"styles_gradient__4N3Jy"};